import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseService } from './base.service.class';
import { NotificationService } from './notification.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class HandoverReportService extends BaseService {
  private dhoApiUrl = `${environment.urlBackend}/dhoapi`;

  constructor(
    private http: HttpClient,
    protected notificationService: NotificationService
  ) {
    super(notificationService);
  }

  getHoAbandonReportData(handoverId: number, wellUwi: string): Observable<any> {
    const url = `${this.dhoApiUrl}/handover/${handoverId}/uwi/${wellUwi}/report`;

    return this.http.get<Blob>(url, {
      observe: 'response',
      responseType: 'blob' as 'json',
    });
  }
}
